$(document).ready(function () {
    let star = $('.stars__li');

    star.on('click', function () {

        if ($(this).parent().hasClass('js-star-edit')) {
            if (!$(this).hasClass('_active')) {
                $(this).prevAll().addClass('_active');
                $(this).addClass('_active');
            } else {
                $(this).nextAll().removeClass('_active');
            }
        }
    })
});



function getStarsVal() {
    let popupOrder = $('.popup-order');
    let popupOrderStars = popupOrder.find('.js-star-edit');
    let popupOrderStar = popupOrderStars.find('.stars__li');
    let hiddenInput = popupOrder.find('.popup-order__stars-hidden');

    popupOrderStars.on('click', function () {
        let count = 0;

        popupOrderStar.each(function (indx, element) {

            if($(element).hasClass('_active')){
                count++
            }
        });

        hiddenInput.val(count);
    });
};

getStarsVal();